// extracted by mini-css-extract-plugin
module.exports = {"container":"Dj","list":"Ej"};